export function sanitizePath(path: string): string {
  return path.replace(/^(.+?)\/?([?#].*)?$/, '$1$2').replace(/^\/\/+/, '/');
}
